/*** IMPORTS FROM imports-loader ***/
var define = false;

import Vue from 'vue';
import ScrollToTop from './ScrollToTop';

Vue.component('ui-scroll-to-top', ScrollToTop);

